import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { TotalDeGrau, totaisPorGrauOrdenados as ordenarTotaisPorGrau } from '../shareds'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardsDeTotaisPorGrau',
  props: {
	totais: { type: Object as PropType<TotalDeGrau> },
},
  setup(__props) {

const props = __props;



const totaisPorGrauOrdenados = computed(() => ordenarTotaisPorGrau(props.totais))

return { __sfc: true,props, totaisPorGrauOrdenados }
}

})